import React from 'react';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';
import './RecruitPage.css';

const JOB_URL = 'https://p-osumitsuki.com/jobs/5a04d0f8-b6ae-44ad-945a-8d1c255e7e33/preview';

const JOBS = [
  {
    id: 'job-1',
    title: '事業開発/事業責任者候補',
    description: '転職のセンター試験OSUMITSUKIの事業開発ポジションです。将来的に事業責任者を任せていきたいと考えています。',
    salary: '年収 400万円〜800万円',
    url: JOB_URL,
  },
  // {
  //   id: 'job-2',
  //   title: 'カスタマーサクセス',
  //   description: '導入企業の採用成功/育成成功に向けた伴走支援。',
  //   salary: '年収 350万円〜600万円',
  //   url: JOB_URL,
  // },
  // {
  //   id: 'job-3',
  //   title: 'コンテンツ/動画ディレクター',
  //   description: '評価の共通言語を広める動画/記事コンテンツの制作。',
  //   salary: '年収 300万円〜500万円',
  //   url: JOB_URL,
  // },
];

function RecruitPage() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: '採用情報', path: '/recruit' }
  ];

  return (
    <div className="recruit-page">
      <SEO page="content" title="採用情報 | PortRay株式会社" />

      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">RECRUIT</p>
          <h1 className="ds-h1">採用情報</h1>
          <p className="ds-lead">
            募集職種から気になるポジションを選択してください。<br />OSUMITSUKI内で詳細を確認できます。
          </p>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <p className="ds-eyebrow">OPEN POSITIONS</p>
          <ul className="recruit-jobs">
            {JOBS.map((job) => (
              <li key={job.id} className="ds-card recruit-job">
                <div className="recruit-job-body">
                  <h2 className="ds-h3">{job.title}</h2>
                  <p className="recruit-job-desc">{job.description}</p>
                </div>
                <div className="recruit-job-side">
                  <p className="ds-num recruit-job-salary">{job.salary}</p>
                  <a
                    href={job.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ds-btn ds-btn--primary ds-btn--arrow"
                  >
                    詳細を見る
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}

export default RecruitPage;


